"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWebSocket = exports.WebSocketProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var aws_config_common_1 = __importDefault(require("@fdha/aws-config-common"));
var common_utils_1 = require("@fdha/common-utils");
var SOCKET_RECONNECTION_TIMEOUT = 1000;
var SOCKET_PING_TIMEOUT = 300000;
var Context = (0, react_1.createContext)({
    addListener: function () { return function () { }; },
    removeListener: function () { },
});
var WebSocketProvider = function (_a) {
    var props = __rest(_a, []);
    var wsRef = (0, react_1.useRef)();
    var _b = (0, react_1.useState)([]), listeners = _b[0], setListeners = _b[1];
    var getSocketUrl = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var token, socketUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, common_utils_1.getToken)()];
                case 1:
                    token = _a.sent();
                    socketUrl = "".concat(aws_config_common_1.default.api.webSocketBaseUrl, "?access_token=").concat(token);
                    return [2 /*return*/, socketUrl];
            }
        });
    }); }, []);
    var attachListeners = (0, react_1.useCallback)(function (ws) {
        ws.onopen = function () {
            // Call all listeners with invalidate event
            listeners.forEach(function (cb) {
                cb({ eventType: 'invalidate' });
            });
        };
        ws.onmessage = function (ev) {
            if (!ev.data)
                return;
            listeners.forEach(function (cb) {
                var parsedData = ev.data
                    ? JSON.parse(ev.data)
                    : null;
                cb(parsedData);
            });
        };
    }, [listeners]);
    // Handling Connect
    (0, react_1.useEffect)(function () {
        var connecting = false;
        var connectToSocket = function () { return __awaiter(void 0, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getSocketUrl()];
                    case 1:
                        url = _a.sent();
                        wsRef.current = new WebSocket(url);
                        attachListeners(wsRef.current);
                        connecting = false;
                        return [2 /*return*/];
                }
            });
        }); };
        var connectionInterval = setInterval(function () {
            var ws = wsRef.current;
            if ((!ws || ws.readyState === WebSocket.CLOSED) && !connecting) {
                connecting = true;
                connectToSocket();
            }
        }, SOCKET_RECONNECTION_TIMEOUT);
        var pingInterval = setInterval(function () {
            var ws = wsRef.current;
            if (ws && ws.readyState === WebSocket.OPEN) {
                ws.send(JSON.stringify({ eventType: 'ping' }));
            }
        }, SOCKET_PING_TIMEOUT);
        return function () {
            var _a;
            (_a = wsRef.current) === null || _a === void 0 ? void 0 : _a.close();
            clearInterval(connectionInterval);
            clearInterval(pingInterval);
        };
    }, [getSocketUrl, attachListeners]);
    var handleAddListener = (0, react_1.useCallback)(function (cb) {
        setListeners(function (prev) { return __spreadArray(__spreadArray([], prev, true), [cb], false); });
    }, []);
    var handleRemoveListener = (0, react_1.useCallback)(function (cb) {
        setListeners(function (prev) {
            return prev.filter(function (listener) {
                return listener !== cb;
            });
        });
    }, []);
    return ((0, jsx_runtime_1.jsx)(Context.Provider, { value: {
            addListener: handleAddListener,
            removeListener: handleRemoveListener,
        }, children: props.children }));
};
exports.WebSocketProvider = WebSocketProvider;
var useWebSocket = function () {
    var _a = (0, react_1.useContext)(Context), addListener = _a.addListener, removeListener = _a.removeListener;
    return { addListener: addListener, removeListener: removeListener };
};
exports.useWebSocket = useWebSocket;
